import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import {
  targetFromRef,
  useArtifactOpener
} from "../artifacts/ArtifactOpenerContext";
import type { ToolResultEntity } from "../refs/toolEntities";

export type OpenEntity = {
  /** Previews the entity in the artifact panel when the surface has a viewer for it, otherwise navigates. */
  open: (entity: ToolResultEntity) => void;
  /** Whether `open` previews in the panel rather than leaving the page. */
  previews: (entity: ToolResultEntity) => boolean;
};

export const useOpenEntity = (): OpenEntity => {
  const navigate = useNavigate();
  const opener = useArtifactOpener();
  const previews = useCallback(
    (e: ToolResultEntity) => opener?.canOpen(e.target.kind) ?? false,
    [opener]
  );
  const open = useCallback(
    (e: ToolResultEntity) => {
      if (opener && opener.canOpen(e.target.kind)) {
        opener.open(targetFromRef(e.target, e.label, e.title));
      } else {
        navigate(e.target.path);
      }
    },
    [opener, navigate]
  );
  return { open, previews };
};
